import { Component } from '@angular/core';
import { NavController, Platform, ToastController } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { Storage } from '@ionic/storage';
import { provider } from '../../providers/provider';
import { CustomizerProvider } from '../../providers/customizer/customizer';
import { Events } from 'ionic-angular';

@Component({
  selector: 'page-coupon',
  templateUrl: 'coupon.html'
})
export class CouponPage {
  data: any;
  url: any;
  width;
  customerPoints = [];
  customerCoupons = null;
  activatedCoupons = [];
  coupon;

  constructor(
    public navCtrl: NavController,
    public translateService: TranslateService, 
    public storage: Storage,
    public toastCtrl: ToastController,
    public events: Events,
    public provider: provider,
    public platform: Platform,
    public customizer: CustomizerProvider) {

    this.data = provider.getMenu().settings;

    this.activatedCoupons = this.provider.getAppliedCoupons();

    this.storage.get('customer').then((customer) => {
      this.provider.getCustomer(JSON.parse(customer)._id).subscribe(data => {
        this.storage.set('customer', (<any>data)._body);
        this.customerPoints = JSON.parse((<any>data)._body).customerPoints;
        this.provider.getCoupons(JSON.parse(customer)._id).subscribe((response) => {
          this.customerCoupons = JSON.parse((<any>response)._body);
          this.customerCoupons.forEach(element => {
            element.isActive = false;
            this.activatedCoupons.forEach(coupon => {
              if(element.code == coupon.code)
                element.isActive = true
            });
          });
        }, (error) => {
          const toast = this.toastCtrl.create({
            message: "Nessun coupon disponibile!",
            duration: 3000,
            position: 'middle'
          });
          toast.present();
          console.log(error)
        });
      }, err => {
        const toast = this.toastCtrl.create({
          message: "Non è stato possibile recuperare i tuoi dati!",
          duration: 3000,
          position: 'middle'
        });
        toast.present();
        console.log(err)
      });
    });
  }

  addCoupon() {
    let obj = {
      code: this.coupon,
      hmac: null,
      isActive: true,
      isPercentage: false,
      value: null
    }
    this.activatedCoupons.push(obj);
    this.customerCoupons.push(obj);
    this.provider.setAppliedCoupons(this.activatedCoupons);
    let toast = this.toastCtrl.create({
      message: 'Coupon attivato!',
      duration: 3000,
      position: 'middle'
    });
    toast.present();
    this.events.publish('coupons:updated', obj);
  }

  activate(coupon) {
    if(coupon.isActive) {
      coupon.isActive = false;
      this.activatedCoupons = this.activatedCoupons.filter((sconto) => sconto.code !== coupon.code);
      this.provider.setAppliedCoupons(this.activatedCoupons);
    } else if(this.data.fidelityCoupon.maxUsage > this.activatedCoupons.length) {
      this.activatedCoupons.push(coupon);
      this.provider.setAppliedCoupons(this.activatedCoupons);
      coupon.isActive = true;
      this.events.publish('coupons:updated', coupon);
      let toast = this.toastCtrl.create({
        message: 'Coupon inserito!',
        duration: 3000,
        position: 'middle'
      });
      toast.present();
    } else if(this.data.fidelityCoupon.maxUsage <= this.activatedCoupons.length) {
      let toast = this.toastCtrl.create({
        message: 'Non puoi inserire più di ' + this.data.fidelityCoupon.maxUsage + " coupon",
        duration: 3000,
        position: 'middle'
      });
      toast.present();
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/coupon/coupon.ts